import { Menu, MenuProps } from "antd";
import Sider from "antd/es/layout/Sider";
import { useLocation, useNavigate } from "react-router-dom";
import allImgPaths from "../../assets";
import { useAppState } from "../../context";

// Define the initial menu items
const baseMenuItems = [
  {
    key: "/dashboard",
    label: "Dashboard",
    icon: <img src={allImgPaths.dashboardIcon} />,
  },
  {
    key: "/member/create",
    label: "Members",
    icon: <img src={allImgPaths.memberIcon} />,
  },
  {
    key: "/member",
    label: "Coins Table",
    icon: (
      <img
        src={allImgPaths.coinTableIcon}
        style={{ width: "30px", height: "25px" }} // Adjust width and height here
        alt="Coins Table Icon"
      />
    ),
  },
];

const Sidebar = () => {
  /*  const [current, setCurrent] = useState("");
  const [openKeys, setOpenKeys] = useState<string[]>([]); */
  const { userData } = useAppState("auth");
  const navigate = useNavigate();
  const { setMembersFilterState, setPSiteFilterState } = useAppState("auth");

  const location = useLocation();

  const clearMemberFilterState = async () => {
    await setMembersFilterState(
      { developer: "", project_site: "", project_type: "" },
      true,
    );
  };

  const clearPSiteFilterState = async () => {
    await setPSiteFilterState(
      { developer: "", city: "", city_id: "", landmark: "", pType: "" },
      true,
    );
  };

  /* const onClick: MenuProps["onClick"] = (e: any) => {
    setCurrent(e.key);
    navigate(e.key);

    if (e.key !== "/member") {
      clearMemberFilterState();
    }

    if (e.key !== "/projectSite") {
      clearPSiteFilterState();
    }

    const parentKey = e.keyPath[1];

    if (parentKey) {
      setOpenKeys(openKeys.includes(parentKey) ? [] : [parentKey]);
    }
  }; */
  const onClick: MenuProps["onClick"] = (e) => {
    if (location.pathname !== e.key) {
      navigate(e.key);
    }

    if (e.key !== "/member") {
      clearMemberFilterState();
    }

    if (e.key !== "/projectSite") {
      clearPSiteFilterState();
    }
  };

  /* const onOpenChange = (keys: string[]) => {
    setOpenKeys(keys.length > 0 ? [keys[keys.length - 1]] : []);
  }; */

  const getFilteredMenuItems = () => {
    const adminMenuItem = {
      key: "/focusmember",
      label: "Focus Member",
      icon: (
        <img
          src={allImgPaths.memberIcon}
          // style={{ width: "30px", height: "25px" }} // Adjust width and height here
          alt="focus member Icon"
        />
      ),
    };

    const weekSettingMenuItem = {
      key: "/week-setting",
      label: "Week Setting",
      icon: (
        <img
          src={allImgPaths.settingOutline}
          // style={{ width: "30px", height: "25px" }} // Adjust width and height here
          alt="focus member Icon"
        />
      ),
    };

    const importMenuItem = {
      key: "/upload-doc",
      label: "Upload Document",
      icon: <img src={allImgPaths.Upload_Icon} alt="upload document" />,
    };

    return userData.is_admin
      ? [...baseMenuItems, adminMenuItem, weekSettingMenuItem, importMenuItem]
      : baseMenuItems;
  };

  return (
    <div className="overflow-y-auto h-full w-full sidebar">
      <Sider
        trigger={null}
        collapsed={true}
        className="pt-[10px] pb-[25px] overflow-auto sidebarScoll w-full h-screen"
      >
        <div className="flex flex-col items-center justify-center h-auto mb-3">
          <div
            className="rounded-full p-2 flex items-center justify-center"
            style={{ height: "100px" }}
          >
            <img
              src={allImgPaths.gvsLogoImg}
              alt="ProfileIcon"
              style={{ height: "60px", width: "60px" }}
              className="rounded-full"
            />
          </div>
        </div>

        {/* <Menu
          mode="inline"
          theme="dark"
          onClick={onClick}
          selectedKeys={[current]}
          openKeys={openKeys}
          onOpenChange={onOpenChange}
          items={getFilteredMenuItems()}
        /> */}
        <Menu
          mode="inline"
          theme="dark"
          selectedKeys={[location.pathname]}
          onClick={onClick}
          items={getFilteredMenuItems()}
        />
      </Sider>
    </div>
  );
};

export default Sidebar;
